export function inputCheckboxDirective() {
    return {
        // language=HTML
        template: `
            <md-input-container>
                <md-checkbox
                    name="{{ name || '' }}"
                    aria-label="{{ ariaLabel || 'Checkbox' }}"
                    ng-model="value"
                    ng-change="_onChange()"
                    ng-disabled="disabled"
                    data-testid="{{ label }}"
                    ng-required="required">
                    {{ label }}
                </md-checkbox>

                <div class="hint" ng-if="hint">
                    {{ hint }}
                </div>

                <md-tooltip ng-if="tooltip">{{ tooltip }}</md-tooltip>

                <div ng-if="form && name" ng-messages="form[name].$error">
                    <div ng-message="required">Required</div>
                    <div ng-message="custom">{{ form[name].customError }}</div>
                    <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{ message }}</div>
                </div>
            </md-input-container>
        `,
        scope: {
            onChange: '&?change',
            disabled: '=ngDisabled',
            errorMessages: '=errorMessages',
            form: '=form',
            hint: '@?hint',
            label: '@label',
            ariaLabel: '@?ariaLabel',
            name: '@name',
            tooltip: '@?tooltip',
            required: '=?required',
            value: '=value',
        },
        link: function(scope, element, attrs) {
            element.addClass('app-form-field');

            scope._onChange = _onChange;

            // If it's undefined on the scope, it may mean that the attribute is there but
            // without content. If the attribute isn't undefined then we know it's been added.
            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }

            function _onChange() {
                if (angular.isFunction(scope.onChange)) {
                    scope.onChange();
                }

                if (!scope.form || !scope.name) {
                    return;
                }

                if (scope.value) {
                    const formControl = scope.form[scope.name];

                    if (formControl) {
                        formControl.$setValidity('custom', true);
                        formControl.customError = null;
                    }
                }
            }
        },
    };
}
